/**
 * @author Andrea Moraglia
 */
export default interface IPlace {
    address: string;
    areaID: number;
    areaOfInterestID: number;
    areaOfInterestName?: string;
    city?: string;
    cityID: number;
    cityName: string;
    cityURL: string;
    completeURL: string;
    countryID: number;
    countryName?: string;
    description: string;
    displayName: string;
    districtID: number;
    districtName: string;
    latitude: number;
    locality?: string;
    localityID: number;
    localityName: string;
    longitude: number;
    placeID: number;
    placeType: string;
    polygon?: string;
    position?: number;
    priority?: number;
    provinceAcronym: string;
    provinceID: number;
    provinceName: string;
    regionID: number;
    regionName: string;
    searchable?: boolean;
    streetName: string;
    streetNumber: string | null;
    url: string;
    urlPartName: string;
    vacation?: boolean;
    zip: string;
    zoneID: number;
    zoneName: string;
    zoneSuffix?: string;
    zoneURL: string;
    subPlaces: IPlace[];
}

export function isValidPlace(place: IPlace): boolean {
    return !!place
        && (place.cityID != null)
        && (place.streetName != null)
        && (place.latitude != null)
        && (place.longitude != null);
}

/* Added by Stefano Soresina for Request interface */
export interface Country {
    countryId: number,
    countryName: string
}

export interface Region {
    regionId: number,
    country: Country
}

export interface Province {
    provinceId: number,
    provinceAcronym: string,
    region: Region
}

export interface City {
    cityId: number,
    province: Province,
    cityName: string,
    cityDisplayName: string,
    istatCode: string,
    longitude: number,
    latitude: number,
    hasHomonymy: boolean
}
